import { useApi } from "hooks"
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GAHandler } from "utils/GA";

const useBuyContent = () => {

  const { apiFetch } = useApi()
  const queryClient = useQueryClient()

  const url = `/payments/content`;

  const buyContent = ({ contentId, price }) => {
    return apiFetch({
      url,
      method:'POST',
      data: {
        contentId,
        price: parseFloat(price)
      }
    })
  }

  const {
    mutateAsync,
    ...rest
  } = useMutation({
    mutationFn: buyContent,
    onSuccess: () => {
      GAHandler('content_buyed');
      queryClient.invalidateQueries({ predicate: (query) => query.queryKey.includes('purchases') })
      queryClient.invalidateQueries(['balance'])
    },
  })

  return {
    buyContent: mutateAsync,
    ...rest,
  }
}

export default useBuyContent;